import React from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import styles from './index.module.css';

function CapitalTermsAccountBookDetailPage(): JSX.Element {
  const brand = import.meta.env.VITE_BRAND as 'KIA' | 'HYUNDAI' | 'GENESIS';
  const {t} = useInferableTranslation();
  const {backOrClose} = useCcWebviewUtilsHelper();

  const WORDS = {
    KIA: {
      company: '기아',
      appName: 'Kia',
      withdrawalName: '기아 대표사이트',
      agreeCode: 'SP10ZKB001',
    },
    HYUNDAI: {
      company: '현대자동차',
      appName: '마이현대',
      withdrawalName: '현대자동차 온라인 서비스',
      agreeCode: 'SP10ZKC001',
    },
    GENESIS: {
      company: '현대자동차',
      appName: 'MY GENESIS',
      withdrawalName: '제네시스 온라인 서비스',
      agreeCode: 'SP10ZKD001',
    },
  };

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header right={<HeaderCloseButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30199')}</h1>
      </Header>
      <main className="content">
        <section className="section section_mileage_consent">
          <div className="section_heading">
            <h2 className="section_heading_title">차계부 자동 등록 이용을 위한 개인(신용)정보 선택적 제공 동의서</h2>
          </div>
          <div className="mileage_consent_detail">
            {/*start 이하 전달받은 약관*/}
            <div className={styles.terms_wrap}>
              <p className={styles.sub_tit}>현대캐피탈 주식회사 귀중</p>

              <div className={styles.rating}>
                <ul>
                  <li className={styles.stage1}>
                    <span>안심</span>
                  </li>
                  <li className={styles.stage2}>
                    <span>다소 안심</span>
                  </li>
                  <li className={styles.stage3}>
                    <span>보통</span>
                  </li>
                  <li className={[styles.stage4, styles.on].join(' ')}>
                    <span>신중</span>
                  </li>
                  <li className={styles.stage5}>
                    <span>주의</span>
                  </li>
                </ul>
              </div>

              <table className={styles.table_basic}>
                <tbody>
                  <tr>
                    <th
                      className={styles.align_left}
                      style={{fontSize: 14}}
                    >
                      제공받는 자
                    </th>
                    <td>
                      <p className={[styles.txt_bold, styles.txt_underline].join(' ')}>{WORDS[brand].company}㈜</p>
                    </td>
                  </tr>
                  <tr>
                    <th
                      className={styles.align_left}
                      style={{fontSize: 14}}
                    >
                      제공받는 자의 이용목적
                    </th>
                    <td>
                      <p className={[styles.txt_bold, styles.txt_underline].join(' ')}>차계부 서비스 내 차량 관련 지출 내역 자동수집 및 기록</p>
                      <ul className={styles.lst_dash}>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>
                          현대캐피탈 자산관리서비스의 카드 결제 내역 차계부 자동등록
                        </li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>지출 항목 자동 분류 및 월간 리포트 제공</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>중복 결제 감지 및 사용자 확인 요청</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <th
                      className={styles.align_left}
                      style={{fontSize: 14}}
                    >
                      보유 및 이용기간
                    </th>
                    <td className={[styles.txt_bold, styles.txt_underline].join(' ')}>
                      <ol className={styles.lst_num}>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>해당 동의 철회</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>차계부 서비스 탈퇴</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>내 차 금융관리 서비스 탈퇴</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>{WORDS[brand].withdrawalName} 탈퇴</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>현대캐피탈 자산관리 서비스 탈퇴</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>현대캐피탈 플러스멤버십 탈퇴</li>
                      </ol>
                    </td>
                  </tr>
                  <tr>
                    <th
                      className={styles.align_left}
                      style={{fontSize: 14}}
                    >
                      거부 권리 및 불이익
                    </th>
                    <td>
                      <p>
                        귀하는 개인(신용)정보의 선택적 제공에 대한 동의를 거부할 수 있고 동의 후에도 언제든지 철회가 가능합니다. 동의하지
                        않으셔도 내 차 금융관리 및 현대캐피탈 자산관리서비스는 정상적으로 이용 가능하며, {WORDS[brand].appName} 차계부
                        서비스의 수기 입력 기능도 이용하실 수 있습니다. 다만 동의하지 않으시는 경우 {WORDS[brand].appName} 차계부 내
                        현대캐피탈 거래내역 자동수집 기능은 이용하실 수 없습니다.
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h2
                className=""
                style={{fontSize: 16}}
              >
                제공 항목
              </h2>
              <table
                className={styles.table_basic}
                style={{fontSize: 14}}
              >
                <colgroup>
                  <col width="35%" />
                  <col width="65%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th colSpan={2}>
                      <p className={styles.align_left}>개인(신용)정보</p>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <p className={styles.align_left}>┗ 일반개인정보</p>
                    </th>
                    <td>
                      <p>CI, 고유번호*, 차대번호</p>
                    </td>
                  </tr>
                  <tr>
                    <th rowSpan={2}>
                      <p className={styles.align_left}>┗ 신용거래정보</p>
                    </th>
                    <td>
                      <p>① 현대캐피탈 자산관리 서비스로 수집한 카드 업권의 가입 상품 및 거래정보 아래 항목</p>
                      <ul className={styles.lst_dash}>
                        <li>
                          금융기관 코드, 금융기관명, 카드명, 카드 식별자, 승인일시, 결제상태, 승인번호, 사용구분코드(신용/체크), 정정 또는
                          승인취소일시, 가맹점명, 가맹점 사업자등록번호, 이용금액, 정정후금액, 전체 할부회차
                        </li>
                      </ul>
                      <p>② 위 일반개인정보 및 신용거래정보를 활용한 고객 분석 정보</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                className={styles.info_box}
                style={{fontSize: 14}}
              >
                <p>※ 고유번호란, CI를 암호화한 정보이며 현대캐피탈과 {WORDS[brand].company}㈜간 통신 연결 및 고객 식별 목적으로 제공합니다.</p>
                <p>
                  ※ 현대캐피탈 앱 또는 {WORDS[brand].appName} 앱에서 위 동의에 따른 마이데이터 제3자 제공 내역을 확인 및 위 동의를 철회할
                  수 있습니다.
                </p>
                <p>※ 동의 철회 시 차계부에 확정 저장된 거래 기록은 별도 삭제 요청 전까지 유지됩니다.</p>
                <p>※ 위 동의에 따라 제휴사에 정보를 유상으로 제공할 수 있습니다.</p>
              </div>
              <p
                className={styles.agree_code}
                style={{fontSize: 14}}
              >
                {WORDS[brand].agreeCode}
              </p>
            </div>
            {/*end 이하 전달받은 약관*/}
          </div>
        </section>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => backOrClose()}
        >
          {t('T10114')}
        </button>
      </div>
    </div>
  );
}

export default CapitalTermsAccountBookDetailPage;
